import React from 'react';
import { Box, MenuItem, Stack, TextField } from '@mui/material';
import { BOOKS, bookFor } from '../utils/books';

/** A sportsbook's color dot (no book: a dashed ring). */
export const BookDot: React.FC<{ book?: string; size?: number }> = ({ book, size = 10 }) => {
  const b = bookFor(book);
  return (
    <Box
      component="span"
      aria-hidden
      sx={{
        display: 'inline-block',
        flex: 'none',
        width: size,
        height: size,
        borderRadius: '50%',
        bgcolor: b?.color ?? 'transparent',
        border: b && !b.ring ? 0 : 1.5,
        borderStyle: b ? 'solid' : 'dashed',
        borderColor: 'text.secondary',
        boxSizing: 'border-box',
      }}
    />
  );
};

export const BookLabel: React.FC<{ book: string }> = ({ book }) => (
  <Stack direction="row" spacing={1} alignItems="center" component="span" sx={{ minWidth: 0 }}>
    <BookDot book={book} />
    <Box component="span" sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
      {book}
    </Box>
  </Stack>
);

/** Picks the sportsbook a bet is at (optional: "No book" clears it). */
export const BookSelect: React.FC<{
  value?: string;
  onChange: (book: string | undefined) => void;
  width?: number | string;
  sx?: object;
}> = ({ value, onChange, width = 156, sx }) => (
  <TextField
    select
    size="small"
    label="Book"
    value={bookFor(value) ? value : ''}
    onChange={(e) => onChange(e.target.value || undefined)}
    sx={{ width, ...sx }}
    SelectProps={{
      displayEmpty: true,
      renderValue: (v) =>
        v ? (
          <BookLabel book={String(v)} />
        ) : (
          <Stack direction="row" spacing={1} alignItems="center" component="span" sx={{ color: 'text.secondary' }}>
            <BookDot />
            <span>Not set</span>
          </Stack>
        ),
    }}
    InputLabelProps={{ shrink: true }}
  >
    <MenuItem value="">
      <Stack direction="row" spacing={1} alignItems="center" component="span" sx={{ color: 'text.secondary' }}>
        <BookDot />
        <span>No book</span>
      </Stack>
    </MenuItem>
    {BOOKS.map((b) => (
      <MenuItem key={b.name} value={b.name}>
        <BookLabel book={b.name} />
      </MenuItem>
    ))}
  </TextField>
);
